import { render } from "./Counter.vue?vue&type=template&id=3e29def2"
import script from "./Counter.vue?vue&type=script&lang=js"
export * from "./Counter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\VS2022\\kirchenbote-online-2022_01\\MD.RMP.KirchenboteOnline.Umb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/multiMostRead/Counter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e29def2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e29def2', __exports__)) {
    api.reload('3e29def2', __exports__)
  }
  
  module.hot.accept("./Counter.vue?vue&type=template&id=3e29def2", () => {
    api.rerender('3e29def2', render)
  })

}


export default __exports__